import { MutationInputError } from 'providers/tanstack-query/errors'

export const fixAttributeDuplicatePaths = (
  attribute: MutationInputError['attribute'],
): MutationInputError['attribute'] => attribute.split('.').slice(1).join('.')
